var _rect, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIllVideosWebXmas = function SvgIllVideosWebXmas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1360,
    height: 364,
    viewBox: "0 0 1360 364",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10463_19921",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1360,
    height: 364
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 364,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10463_19921)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10463_19921",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -267,
    y: -36,
    width: 1927,
    height: 389
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M696.249 158.5C225.658 158.5 -121.01 282 -266 342V-35H1659V352C1455.31 270 1105.13 158.5 696.249 158.5Z",
    fill: "#D9D9D9",
    stroke: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10463_19921)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.61 198.218C1114.15 191.422 1116.53 180.159 1117.02 179.379L1100.57 172.521L1090.15 176.731C1089.84 180.245 1086.52 191.324 1085.77 192.423L1115.61 198.218Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.45 164.644C1044.57 158.779 1055 150.798 1060.39 148.311C1058.61 147.93 1055.93 145.852 1059.53 140.579C1063.12 135.306 1074.85 129.586 1080.27 127.385C1078.37 127.307 1074.48 126.293 1074.1 122.856C1072.83 114.648 1090.3 107.996 1094.79 105.319C1088.29 105.611 1088.9 95.5394 1096.31 91.666C1104.14 87.5755 1106.88 84.8303 1112.23 82.0567C1117.58 79.2831 1117.2 79.7608 1119.5 84.7228C1121.8 89.6847 1128.35 93.7357 1133.23 98.4088C1139.47 107.453 1131.97 109.277 1127.45 109.059C1129.89 111.395 1139.51 117.331 1143.95 124.174C1148.16 130.662 1140.9 134.519 1137.31 134.92C1139.37 137.734 1144.54 141.071 1150.42 146.936C1155.74 157.127 1145.13 155.501 1139 153.868C1144.26 158.064 1159.29 171.671 1156.84 177.097C1153.22 185.157 1144.78 179.606 1141.02 175.823C1142.75 191.287 1122.28 183.573 1119.69 176.034C1112.43 189.024 1101 180.3 1100.71 173.809C1089.67 188.091 1081.63 174.639 1082.68 168.432C1069.59 183.815 1057.92 169.029 1063.36 163.2C1059.78 166.211 1054.58 168.752 1050.45 164.644Z",
    fill: "#32BF5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.36 105.367C1096.56 105.556 1101.6 105.427 1104.16 103.4C1104.58 107.123 1106.87 114.406 1114.45 113.558C1119.18 113.028 1121.47 107.552 1119.99 104.674C1121.44 105.961 1125.05 108.631 1127.88 109.01M1078.98 127.529C1081.19 127.861 1086.51 127.904 1090.07 125.418C1087.92 133.487 1097.15 145.85 1108.96 126.785C1111.3 132.176 1117.06 142.159 1123.16 140.852C1127.42 139.941 1128.42 133.305 1127.17 129.965C1128.83 131.809 1133.23 135.029 1137.74 134.872",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.39 148.312C1063.28 148.134 1069.69 147.272 1072.25 145.246C1071.68 151.833 1080.1 160.894 1090.18 149.763C1089.56 155.921 1094.93 164.976 1105.86 153.662C1106.25 161.013 1116.92 166.778 1122.12 154.888C1126.38 161.805 1136.94 166.625 1139 153.869",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.72 80.9104C1111.24 84.0832 1109.76 84.6542 1109.46 84.5431L1112.23 78.1445L1105.48 76.2893L1111.03 75.2339C1109.8 73.3417 1107.51 69.452 1108.16 69.0312C1108.81 68.6104 1112.32 72.4799 1113.99 74.4673C1114.63 72.3665 1116 68.2411 1116.38 68.5462C1116.76 68.8514 1117.02 72.9688 1117.1 74.9894C1119.76 74.1118 1125.1 72.4424 1125.13 72.7861C1125.17 73.1297 1121.36 75.3831 1119.45 76.4668C1121.63 77.8172 1125.92 80.6134 1125.62 80.9955C1124.97 81.4162 1120.63 80.5389 1118.54 80.0476C1117.79 82.4509 1116.2 87.181 1115.82 86.8759C1115.44 86.5708 1114.92 82.7718 1114.72 80.9104Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1122.21,
    cy: 151.832,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1122.21 151.832)",
    fill: "#ED1B98"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1122.21,
    cy: 151.832,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1122.21 151.832)",
    fill: "#ED1B98"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1131.49,
    cy: 149.053,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1131.49 149.053)",
    fill: "#ED1B98"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1131.49,
    cy: 149.053,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1131.49 149.053)",
    fill: "#ED1B98"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1137.7,
    cy: 142.269,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1137.7 142.269)",
    fill: "#ED1B98"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1137.7,
    cy: 142.269,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1137.7 142.269)",
    fill: "#ED1B98"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1126.88,
    cy: 115.645,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1126.88 115.645)",
    fill: "#ED1B98"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1126.88,
    cy: 115.645,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1126.88 115.645)",
    fill: "#ED1B98"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1115.98,
    cy: 119.475,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1115.98 119.475)",
    fill: "#ED1B98"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1115.98,
    cy: 119.475,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1115.98 119.475)",
    fill: "#ED1B98"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1103.84,
    cy: 119.963,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1103.84 119.963)",
    fill: "#ED1B98"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1103.84,
    cy: 119.963,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1103.84 119.963)",
    fill: "#ED1B98"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1094.56,
    cy: 114.913,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1094.56 114.913)",
    fill: "#ED1B98"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1094.56,
    cy: 114.913,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1094.56 114.913)",
    fill: "#ED1B98"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1085.28,
    cy: 109.863,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1085.28 109.863)",
    fill: "#ED1B98"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1085.28,
    cy: 109.863,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1085.28 109.863)",
    fill: "#ED1B98"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1122.21,
    cy: 151.832,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1122.21 151.832)",
    fill: "#ED1B98"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1122.21,
    cy: 151.832,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1122.21 151.832)",
    fill: "#ED1B98"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1122.89,
    cy: 165.674,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1122.89 165.674)",
    fill: "#F6D703"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1101.52,
    cy: 167.411,
    rx: 2.38133,
    ry: 2.37723,
    transform: "rotate(-6.38394 1101.52 167.411)",
    fill: "#ED1B98"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1089.76,
    cy: 163.509,
    rx: 2.38133,
    ry: 2.37723,
    transform: "rotate(-6.38394 1089.76 163.509)",
    fill: "#ED1B98"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.46,
    cy: 166.961,
    rx: 2.38133,
    ry: 2.37723,
    transform: "rotate(-6.38394 1074.46 166.961)",
    fill: "#ED1B98"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1062.98,
    cy: 157.808,
    rx: 2.38133,
    ry: 2.37723,
    transform: "rotate(-6.38394 1062.98 157.808)",
    fill: "#ED1B98"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1135.61,
    cy: 170.34,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1135.61 170.34)",
    fill: "#F6D703"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1147.85,
    cy: 170.71,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1147.85 170.71)",
    fill: "#F6D703"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.01,
    cy: 133.739,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1074.01 133.739)",
    fill: "#ED1B98"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.01,
    cy: 133.739,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1074.01 133.739)",
    fill: "#ED1B98"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.01,
    cy: 133.739,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1074.01 133.739)",
    fill: "#ED1B98"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.01,
    cy: 133.739,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1074.01 133.739)",
    fill: "#ED1B98"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.01,
    cy: 133.739,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1074.01 133.739)",
    fill: "#F6D703"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.01,
    cy: 133.739,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1074.01 133.739)",
    fill: "#F6D703"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.01,
    cy: 133.739,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1074.01 133.739)",
    fill: "#F6D703"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.01,
    cy: 133.739,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1074.01 133.739)",
    fill: "#F6D703"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.01,
    cy: 133.739,
    rx: 2.16485,
    ry: 2.16112,
    transform: "rotate(-6.38394 1074.01 133.739)",
    fill: "#F6D703"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1124.91,
    cy: 96.0762,
    rx: 2.38133,
    ry: 2.37723,
    transform: "rotate(-6.38394 1124.91 96.0762)",
    fill: "#F6D703"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1112,
    cy: 97.5225,
    rx: 2.38133,
    ry: 2.37723,
    transform: "rotate(-6.38394 1112 97.5225)",
    fill: "#F6D703"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1113.94,
    cy: 138.188,
    rx: 2.38133,
    ry: 2.37723,
    transform: "rotate(-6.38394 1113.94 138.188)",
    fill: "#F6D703"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1106.67,
    cy: 143.349,
    rx: 2.38133,
    ry: 2.37723,
    transform: "rotate(-6.38394 1106.67 143.349)",
    fill: "#F6D703"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.58,
    cy: 145.461,
    rx: 2.38133,
    ry: 2.37723,
    transform: "rotate(-6.38394 1095.58 145.461)",
    fill: "#F6D703"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1082.95,
    cy: 141.653,
    rx: 2.38133,
    ry: 2.37723,
    transform: "rotate(-6.38394 1082.95 141.653)",
    fill: "#F6D703"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.7 88.8598C1105.21 89.6733 1104.92 90.8068 1103.41 91.3708C1102.28 91.8911 1101.01 91.8086 1100.59 90.8978C1100.07 89.7728 1100.76 88.9072 1101.89 88.3863C1102.95 87.896 1103.79 87.7792 1104.7 88.8598Z",
    fill: "#F6D703"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.5 115.527C1136.19 116.434 1135.13 116.937 1133.73 116.13C1132.61 115.596 1131.87 114.567 1132.3 113.662C1132.84 112.543 1133.95 112.524 1135.07 113.058C1136.12 113.56 1136.75 114.137 1136.5 115.527Z",
    fill: "#ED1B98"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.5 115.527C1136.19 116.434 1135.13 116.937 1133.73 116.13C1132.61 115.596 1131.87 114.567 1132.3 113.662C1132.84 112.543 1133.95 112.524 1135.07 113.058C1136.12 113.56 1136.75 114.137 1136.5 115.527Z",
    fill: "#ED1B98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.92 91.4976C1124.47 92.2014 1123.47 92.4083 1122.45 91.4349C1121.61 90.7503 1121.2 89.7251 1121.75 89.0487C1122.44 88.2132 1123.38 88.4271 1124.22 89.1113C1125.01 89.7548 1125.42 90.3737 1124.92 91.4976Z",
    fill: "#F6D703"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.81 131.231C1079.81 131.231 1078.53 130.38 1075.92 130.431C1073.3 130.481 1070 130.913 1070 128.297C1070 125.682 1070.8 123.015 1070.96 120.945C1071.13 118.876 1070.8 113.212 1073.1 113.06C1075.4 112.908 1075.98 114.228 1076.4 116.362C1076.4 116.362 1077.83 112.692 1079.85 113.022C1081.87 113.352 1081.69 114.076 1082.1 117.111C1082.42 118.126 1082.15 118.66 1084.28 119.244C1086.42 119.828 1092.33 121.06 1096.44 126.393C1098.09 129.059 1098.04 137.478 1091.48 139.294C1084.93 141.109 1083.07 138.76 1082.95 136.526C1082.88 134.913 1083.32 133.872 1084.03 133.3C1084.3 133.084 1084.6 132.932 1084.93 132.843C1086.1 132.526 1087.23 132.145 1087.23 132.145C1087.23 132.145 1083.23 132.513 1079.81 131.243L1079.81 131.231Z",
    fill: "#F6D703"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10463_19921",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1069,
    y: 113,
    width: 29,
    height: 27
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.81 131.231C1079.81 131.231 1078.53 130.38 1075.92 130.431C1073.3 130.481 1070 130.913 1070 128.297C1070 125.682 1070.8 123.015 1070.96 120.945C1071.13 118.876 1070.8 113.212 1073.1 113.06C1075.4 112.908 1075.98 114.228 1076.4 116.362C1076.4 116.362 1077.83 112.692 1079.85 113.022C1081.87 113.352 1081.69 114.076 1082.1 117.111C1082.42 118.126 1082.15 118.66 1084.28 119.244C1086.42 119.828 1092.33 121.06 1096.44 126.393C1098.09 129.059 1098.04 137.478 1091.48 139.294C1084.93 141.109 1083.07 138.76 1082.95 136.526C1082.88 134.913 1083.32 133.872 1084.03 133.3C1084.3 133.084 1084.6 132.932 1084.93 132.843C1086.1 132.526 1087.23 132.145 1087.23 132.145C1087.23 132.145 1083.23 132.513 1079.81 131.243L1079.81 131.231Z",
    fill: "#F6D703"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10463_19921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1089.05 128.285C1092.41 128.285 1095.14 125.556 1095.14 122.19C1095.14 118.824 1092.41 116.095 1089.05 116.095C1085.68 116.095 1082.95 118.824 1082.95 122.19C1082.95 125.556 1085.68 128.285 1089.05 128.285Z",
    fill: "url(#paint0_radial_10463_19921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.09 131.764C1071.46 131.764 1074.19 129.035 1074.19 125.669C1074.19 122.303 1071.46 119.574 1068.09 119.574C1064.73 119.574 1062 122.303 1062 125.669C1062 129.035 1064.73 131.764 1068.09 131.764Z",
    fill: "url(#paint1_radial_10463_19921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.36 144.766C1090.72 144.766 1093.45 142.037 1093.45 138.671C1093.45 135.305 1090.72 132.576 1087.36 132.576C1083.99 132.576 1081.26 135.305 1081.26 138.671C1081.26 142.037 1083.99 144.766 1087.36 144.766Z",
    fill: "url(#paint2_radial_10463_19921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.79 135.484C1099.43 135.484 1101.57 133.347 1101.57 130.71C1101.57 128.073 1099.43 125.936 1096.79 125.936C1094.15 125.936 1092.02 128.073 1092.02 130.71C1092.02 133.347 1094.15 135.484 1096.79 135.484Z",
    fill: "url(#paint3_radial_10463_19921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.42 135.484C1083.06 135.484 1085.2 133.347 1085.2 130.71C1085.2 128.073 1083.06 125.936 1080.42 125.936C1077.79 125.936 1075.65 128.073 1075.65 130.71C1075.65 133.347 1077.79 135.484 1080.42 135.484Z",
    fill: "url(#paint4_radial_10463_19921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.42 118.838C1083.06 118.838 1085.2 116.7 1085.2 114.063C1085.2 111.427 1083.06 109.289 1080.42 109.289C1077.79 109.289 1075.65 111.427 1075.65 114.063C1075.65 116.7 1077.79 118.838 1080.42 118.838Z",
    fill: "url(#paint5_radial_10463_19921)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.43 121.25C1079.37 121.25 1080.12 120.494 1080.12 119.561C1080.12 118.628 1079.37 117.872 1078.43 117.872C1077.5 117.872 1076.74 118.628 1076.74 119.561C1076.74 120.494 1077.5 121.25 1078.43 121.25Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.04 121.008C1078.75 121.008 1079.33 120.428 1079.33 119.713C1079.33 118.998 1078.75 118.418 1078.04 118.418C1077.32 118.418 1076.74 118.998 1076.74 119.713C1076.74 120.428 1077.32 121.008 1078.04 121.008Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.94 121.466C1074.94 121.466 1075.55 122.977 1076.97 121.567",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.09 120.856C1075.02 120.856 1075.78 120.1 1075.78 119.167C1075.78 118.235 1075.02 117.479 1074.09 117.479C1073.16 117.479 1072.4 118.235 1072.4 119.167C1072.4 120.1 1073.16 120.856 1074.09 120.856Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.7 120.615C1074.41 120.615 1074.99 120.035 1074.99 119.32C1074.99 118.604 1074.41 118.024 1073.7 118.024C1072.98 118.024 1072.4 118.604 1072.4 119.32C1072.4 120.035 1072.98 120.615 1073.7 120.615Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.83 114.952C1081.54 112.793 1079.86 113.022 1079.86 113.022C1079.08 113.015 1077.3 113.701 1076.5 116.501C1076.55 116.329 1076.5 113.001 1073.5 113.001C1070.5 113.001 1071.5 118.001 1071 120.501",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.46 191.003C1130.48 190.59 1130.18 191.103 1129.88 191.52C1128.75 193.083 1127.2 195.773 1126.49 197.845C1126.2 198.672 1126.63 198.739 1126.95 198.89C1129.56 200.424 1135.32 203.583 1135.71 203.764C1136.09 203.945 1136.39 203.606 1136.49 203.415C1137 203.002 1140.54 197.298 1140.93 196.625C1141.32 195.951 1140.55 195.678 1140.66 195.742C1137.29 193.799 1132.7 191.519 1131.46 191.003Z",
    fill: "#2FCDF2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.08 192.643C1136.84 191.389 1138.85 189.05 1140.8 189.732C1141.56 190.022 1142.81 191.046 1141.74 192.821C1141.14 193.819 1138.93 195.019 1136.57 193.868C1136.53 193.849 1136.49 193.828 1136.45 193.804C1135.87 195.682 1133.43 199.959 1132.25 201.918L1130.05 200.769C1131.22 199.186 1133.26 194.679 1134.2 192.431C1133.13 191.704 1131.21 190.104 1132.62 188.801C1134.03 187.483 1135.62 188.782 1135.93 189.206C1136.31 189.72 1137.05 190.46 1136.08 192.643Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.1 192.818C1137.75 192.028 1139.43 190.593 1140.26 191.603C1140.58 192 1139.66 192.933 1137.1 192.818Z",
    fill: "#F6D703"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1135.27 191.814C1135.2 191.094 1134.83 189.731 1133.92 190.038C1133 190.345 1134.44 191.35 1135.27 191.814Z",
    fill: "#F6D703"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M306.885 130.738V125.667L311.294 120.439L316.53 125.581V130.738",
    fill: "#ED1B98"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M311.293 120.439H328.957L334.023 125.496L316.53 125.581L311.293 120.439Z",
    fill: "#0066FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M334.023 125.496H316.53V131.194H334.023V125.496Z",
    fill: "#FCAEE0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M284.627 138.272L262.625 166.347H274.439L295.456 145.366L284.627 138.272Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M363.344 164.936V196.814H314.561V157.302L363.344 164.936Z",
    fill: "#FCAEE0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M313.905 160.308L319.912 167.444H363.059V198.708",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M269.802 196.814V156.932L290.348 131.065L314.361 159.382V195.105L269.802 196.814Z",
    fill: "#ED1B98"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M314.047 159.396H270.515V196.828H314.047V159.396Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M314.047 159.396L270.515 196.828",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M314.047 196.828L270.515 159.396",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M290.276 131.08L290.619 130.738L320.396 166.005L370.335 166.148V166.789L320.325 166.889L290.276 131.08Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M340.016 130.695L290.619 130.738L320.397 166.005L370.335 166.148L340.016 130.695Z",
    fill: "#0066FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M289.679 139.604L291.799 145.323L297.527 147.438L291.799 149.554L289.679 155.272L287.56 149.554L281.832 147.438L287.56 145.323L289.679 139.604Z",
    fill: "#F6D703"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M290.393 130.346C297.289 136.518 312.651 145.871 318.929 131.058C324.161 136.518 336.479 144.447 343.898 135.331",
    stroke: "black",
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M315.362 163.106C316.075 166.43 318.786 171.653 323.923 171.653C329.059 171.653 331.77 168.804 332.484 166.667C333.435 169.041 336.051 171.653 341.045 171.653C345.325 171.653 349.13 168.092 348.892 166.667C350.081 168.804 352.285 170.94 357.453 170.94C362.447 170.94 364.349 168.329 364.587 166.667",
    stroke: "black",
    strokeWidth: 0.5
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.271,
    cy: 139.106,
    rx: 0.927431,
    ry: 0.925835,
    fill: "#F6D703"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.442,
    cy: 139.106,
    rx: 0.927431,
    ry: 0.925835,
    fill: "#F6D703"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.856,
    cy: 170.441,
    rx: 0.927431,
    ry: 0.925835,
    fill: "#F6D703"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.978,
    cy: 171.153,
    rx: 0.927431,
    ry: 0.925835,
    fill: "#F6D703"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 354.1,
    cy: 170.441,
    rx: 0.927431,
    ry: 0.925835,
    fill: "#F6D703"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 329.844,
    cy: 170.441,
    rx: 0.927431,
    ry: 0.925835,
    fill: "#ED0080"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.539,
    cy: 170.441,
    rx: 0.927431,
    ry: 0.925835,
    fill: "#ED0080"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.661,
    cy: 169.73,
    rx: 0.927431,
    ry: 0.925835,
    fill: "#ED0080"
  })))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M185.959 219C185.959 219 177.753 215.139 177.914 209.053C178.076 202.967 186.12 207.762 187.422 213.516C187.422 213.516 186.554 204.602 192.182 198.86C197.809 193.118 200.227 197.237 199.88 200.655C199.532 204.073 199.966 210.602 192.616 216.947L185.959 219Z",
    fill: "#3CC265"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M524.676 165.799C524.676 165.799 521.153 163.045 522.062 159.836C522.97 156.627 525.348 157.676 525.585 160.985C525.585 160.985 527.765 154.729 531.762 156.233C535.759 157.738 528.136 166.061 527.102 166C526.067 165.938 524.684 165.807 524.684 165.807L524.676 165.799Z",
    fill: "#32BF5E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.68 185.989C1034.68 185.989 1029.13 182.709 1030.01 174.546C1030.89 166.384 1034.39 168.478 1035.18 170.465C1035.96 172.452 1037.31 177.346 1036.82 178.596C1036.56 179.258 1037.36 179.824 1037.72 178.735C1038.07 176.801 1036.65 173.157 1036.93 171.469C1037.22 169.781 1039.96 158.434 1043.85 159.022C1047.74 159.61 1042.39 176.341 1040.15 178.435C1040.15 178.435 1045.41 172.965 1048.24 175.049C1051.06 177.132 1044.44 186 1039.56 186H1034.68V185.989Z",
    fill: "#3CC265"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M340.492 221.165C340.492 221.165 360.068 213.629 375.2 225.868C375.2 225.868 389.733 212.054 412.94 221.713C412.94 221.713 426.356 209.914 449.239 213.1C449.239 213.1 432.691 206.045 414.803 213.555C414.803 213.555 391.802 201.966 372.675 217.369C372.675 217.369 359.814 212.804 340.482 221.165L340.492 221.165Z",
    fill: "#F6D703"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.18 272.548C1052.18 272.548 1071.56 269.303 1083.16 283.372C1083.16 283.372 1099.09 273.418 1118.58 286.631C1118.58 286.631 1133.11 278.313 1153.52 285.539C1153.52 285.539 1139.65 275.957 1121.82 279.499C1121.82 279.499 1102.88 264.546 1082.44 275.101C1082.44 275.101 1071.49 268.497 1052.18 272.548Z",
    fill: "#F6D703"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.41 189.5C1073.41 189.5 1142.34 200.563 1181.5 209",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M917.056 206.79C917.056 206.79 939.674 204.356 952.427 220.884C952.427 220.884 971.371 210.7 993.315 226.764C993.315 226.764 1010.55 218.333 1033.85 227.712C1033.85 227.712 1018.25 216.088 997.416 218.948C997.416 218.948 976.193 200.973 951.99 211.545C951.99 211.545 939.623 203.447 917.046 206.787L917.056 206.79Z",
    fill: "#F6D703"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M384.973 197.133C382.764 197.795 382.967 199.062 383.04 200.165C383.316 204.299 384.417 210.903 386.077 215.322C386.74 217.086 387.549 216.608 388.286 216.425C394.727 215.414 408.659 212.787 409.543 212.566C410.426 212.346 410.463 211.372 410.371 210.913C410.647 209.535 408.714 195.204 408.438 193.551C408.162 191.897 406.506 192.494 406.782 192.448C398.5 193.826 387.733 196.306 384.973 197.133Z",
    fill: "#0066FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M394.911 193.55C394.451 190.426 394.579 183.794 398.776 182.25C400.432 181.699 403.91 181.699 404.573 186.109C404.946 188.589 402.917 193.605 397.395 194.927C397.312 194.942 397.219 194.959 397.117 194.977C398.733 198.889 400.53 209.351 401.26 214.219L396.015 215.321C395.802 211.077 393.015 200.789 391.493 195.764C388.7 196.029 383.323 195.978 383.868 191.896C384.42 187.762 388.837 187.762 389.942 188.038C391.281 188.372 393.53 188.589 394.911 193.55Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M396.844 192.446C396.844 190.241 397.672 185.556 400.433 186.107C401.519 186.324 401.261 189.139 396.844 192.446Z",
    fill: "#32BF5E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M392.427 193.273C391.323 192.17 388.838 190.406 387.734 192.17C386.63 193.934 390.403 193.64 392.427 193.273Z",
    fill: "#32BF5E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10463_19921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1089.05 122.19) scale(6.0949 6.09492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EC1E98",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EC1E98",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EC1E98",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EC1E98",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EC1E98",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10463_19921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1068.09 125.669) scale(6.0949 6.09492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EC1E98",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EC1E98",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EC1E98",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EC1E98",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EC1E98",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10463_19921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1087.36 138.671) scale(6.0949 6.09491)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#EC1E98",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EC1E98",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EC1E98",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EC1E98",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10463_19921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1096.79 130.71) scale(4.77433 4.77436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#32CDF1",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#32CDF1",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#32CDF1",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#32CDF0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10463_19921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1080.42 130.71) scale(4.77433 4.77436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#32CDF1",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#32CDF1",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF1",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#32CDF1",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_10463_19921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1080.42 114.063) scale(4.77433 4.77436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#32CDF1",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#32CDF1",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#32CDF1",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32CDF0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllVideosWebXmas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ill_videos_web_xmas.d4d82c30.svg";
export { ForwardRef as ReactComponent };